import { createStyles } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles((theme) =>
  createStyles({
    header: {
      display: 'flex',
      alignItems: 'center',
      padding: theme.spacing(2),
    },
    headerText: { flex: 1, minWidth: 0 },
    headerTitleRow: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1),
    },
    headerTitle: { fontWeight: 700, fontSize: '1rem', lineHeight: 1.2 },
    headerSubtitle: {
      fontSize: '0.8rem',
      color: theme.palette.text.secondary,
      marginTop: 2,
    },
    closeBtn: { padding: 4, color: theme.palette.text.secondary },

    entry: {
      padding: theme.spacing(1.5, 2),
      borderTop: `1px solid ${theme.palette.divider}`,
    },
    entryMeta: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(0.75),
      flexWrap: 'wrap',
      marginBottom: theme.spacing(0.5),
    },
    entryDate: {
      fontSize: '0.75rem',
      color: theme.palette.text.secondary,
      marginLeft: theme.spacing(0.5),
    },
    entryTitle: { fontWeight: 600, fontSize: '0.95rem', lineHeight: 1.3 },

    footer: {
      padding: theme.spacing(1.5, 2),
      borderTop: `1px solid ${theme.palette.divider}`,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      color: theme.palette.primary.main,
      fontWeight: 600,
      fontSize: '0.875rem',
      cursor: 'pointer',
      '&:hover': { backgroundColor: theme.palette.action.hover },
    },
  })
);
